module.exports = __webpack_public_path__ + "img/target-2-svgrepo-com.464b6af0.svg";